import * as tslib_1 from "tslib";
import { Component } from 'vue-property-decorator';
import MaterialCard from "@/components/Base/MaterialCard/MaterialCard.vue";
import MaterialAvatar from "@/components/Base/MaterialAvatar/MaterialAvatar.vue";
import InputField from '@/components/InputField/InputField.vue';
import UserService from '@/services/UserService';
import Sentinel from '@/classes/Sentinel';
import { Company } from '@/models/Company';
import CompanyService from '@/services/CompanyService';
import JSPage from '@/classes/JSPage';
let ProfilePage = class ProfilePage extends JSPage {
    constructor() {
        super(...arguments);
        this.userService = new UserService();
        this.company = new Company();
        this.companyService = new CompanyService();
    }
    created() {
        super.created();
    }
    main() {
        if (this.user.id_company) {
            this.getCompany();
        }
    }
    update() {
        this.userService.update(this.user).subscribe((user) => {
            Sentinel.setUser(user);
        }, (error) => { });
    }
    getCompany() {
        this.companyService.get(this.user.id_company.value).subscribe((company) => {
            this.company = new Company(company);
        });
    }
};
ProfilePage = tslib_1.__decorate([
    Component({
        components: {
            MaterialCard,
            MaterialAvatar,
            InputField
        }
    })
], ProfilePage);
export default ProfilePage;
